module.exports = __webpack_public_path__ + "static/media/208-Arzt_ID_29.4989c8bb.mp3";